import BackboneDispatcher from 'lib/backbone_dispatcher.js'
import Inflector from 'utils/platform/inflector.js'

export default class BaseImportProjectsView extends Backbone.View
  className: "new-project-form-wrapper"

  initialize: (options) ->
    @dispatcher = BackboneDispatcher.get_instance()
    @collection = options.collection
    @inflector = new Inflector()
    @afterSearch = options.afterSearch
    @importInProgress = false
    @onCancel = @options.onCancel

  next: ->
    return if @importInProgress
    @importInProgress = true
    @startImport()

  render: ->
    @$el.html(@renderedHtml())
    contently.ui.setup_validation @$el
    this

  remove: ->
    @onCancel() if @onCancel
    @clipPublicationView.remove() if @clipPublicationView
    super()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/base_import_projects_view.js.coffee